

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import PinService from "services/PinService";

let initialState = { exist: null };

export const pinExist = createAsyncThunk(
    "pin/pinExist",
    async () => {
        const response = await PinService.pinExist();
        return response?.results?.isPinExist;
    }
);


export const addPin = createAsyncThunk(
    "pin/addPin",
    async (body) => {
        const response = await PinService.addPin(body);
        return response?.status;
    }
);



const pinSlice = createSlice({
    name: "pin",
    initialState: LoadingAdapter.getInitialState(initialState),
    reducers: {

    },
    extraReducers: (builder) => {
        LoadingAdapter.applyAsyncBuilder(pinExist, builder, ["exist"]);
        LoadingAdapter.applyAsyncBuilder(addPin, builder, ["exist"])
    },
});

export default pinSlice.reducer;


// export const selectUnReadNotification = (state) => state.adminNotification.list.filter(x => !x.isRead);